import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("cvt_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const getToken = () => localStorage.getItem("cvt_token");

export function apiError(e) {
  const clean = (s) => String(s).replace(/^Value error,\s*/i, "");
  const d = e?.response?.data?.detail;
  if (d == null) return e.message || "Une erreur est survenue.";
  if (typeof d === "string") return clean(d);
  if (Array.isArray(d)) return d.map((x) => clean(x?.msg || JSON.stringify(x))).join(" ");
  return clean(d);
}
